import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from './client'

export const forbiddenWordsKeys = {
  all: ['forbiddenWords'] as const,
  detail: () => [...forbiddenWordsKeys.all, 'detail'] as const,
}

export const useForbiddenWords = () => {
  return useQuery({
    queryKey: forbiddenWordsKeys.detail(),
    queryFn: async () => {
      const response = await api.get<{ forbidden_words: string[] }>('/companies/me/forbidden-words')
      return response
    },
    staleTime: 2 * 60 * 1000,
  })
}

export const useUpdateForbiddenWords = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (words: string[]) => {
      return api.put<{ message: string; count: number }>('/companies/me/forbidden-words', {
        forbidden_words: words,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: forbiddenWordsKeys.all })
    },
  })
}
